import { asApiFailure } from "@utils/apiFailure";

// Inline copy for the failures of GET /invoices/{id}/pdf. The contracted ones
// — the exact set useInvoiceApi's predicate hides from useApi's global toast:
// 403, and the two DIFFERENT 404s the API sends with distinct string bodies (a
// missing invoice row vs. a row whose PDF is gone from storage: "Invoice PDF
// is no longer available.") — get their own sentence. Everything else (the
// hook's DownloadError, a 5xx, a network failure) gets one generic
// sentence: never undefined, because an empty inline slot after a failed
// download reads as a saved file. useApi's toast fires as well for the
// failures it handles; the two do not conflict.

export const INVOICE_FORBIDDEN_MESSAGE =
    "You don't have permission to download this invoice.";

export const INVOICE_NOT_FOUND_MESSAGE =
    "This invoice could not be found. It may have been removed.";

export const INVOICE_PDF_GONE_MESSAGE =
    "This invoice's PDF is no longer available. Contact support for a copy.";

export const INVOICE_DOWNLOAD_FAILED_MESSAGE =
    "The invoice couldn't be downloaded. Try again.";

export const invoiceDownloadErrorMessage = (error: unknown): string => {
    const failure = asApiFailure(error);

    switch (failure?.status) {
        case 403:
            return INVOICE_FORBIDDEN_MESSAGE;

        case 404:
            // The body reaches us as text/plain or as a JSON string literal
            // depending on the output formatter (see apiSentence in @utils/apiFailure);
            // a substring match reads both.
            return /no longer available/i.test(failure.detail ?? "")
                ? INVOICE_PDF_GONE_MESSAGE
                : INVOICE_NOT_FOUND_MESSAGE;

        default:
            return INVOICE_DOWNLOAD_FAILED_MESSAGE;
    }
};
